/**
 * Generated by orval 🍺
 * Do not edit manually.
 * PASS API
 * OpenAPI spec version: 3.0.0
 */
import { useQuery } from "@tanstack/react-query";

import { nmibleInstanceV3 } from "../../mutator/axios-instance-v3";

import type {
  GetPaymentsPaymentsGetParams,
  HTTPValidationError,
  PaymentListResponse,
} from "../../model";
import type { ErrorType } from "../../mutator/axios-instance-v3";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Payments
 */
export const getPaymentsPaymentsGet = (
  params?: GetPaymentsPaymentsGetParams,
  options?: SecondParameter<typeof nmibleInstanceV3>,
  signal?: AbortSignal
) => {
  return nmibleInstanceV3<PaymentListResponse>(
    { url: `/payments`, method: "GET", params, signal },
    options
  );
};

export const getGetPaymentsPaymentsGetQueryKey = (
  params?: GetPaymentsPaymentsGetParams
) => {
  return [`/payments`, ...(params ? [params] : [])] as const;
};

export const getGetPaymentsPaymentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPaymentsPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPaymentsPaymentsGetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPaymentsPaymentsGet>>
  > = ({ signal }) => getPaymentsPaymentsGet(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPaymentsPaymentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPaymentsPaymentsGet>>
>;
export type GetPaymentsPaymentsGetQueryError = ErrorType<HTTPValidationError>;

export function useGetPaymentsPaymentsGet<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params: undefined | GetPaymentsPaymentsGetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsPaymentsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentsPaymentsGet<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPaymentsPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
          TError,
          Awaited<ReturnType<typeof getPaymentsPaymentsGet>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetPaymentsPaymentsGet<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPaymentsPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Payments
 */

export function useGetPaymentsPaymentsGet<
  TData = Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
  TError = ErrorType<HTTPValidationError>,
>(
  params?: GetPaymentsPaymentsGetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPaymentsPaymentsGet>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof nmibleInstanceV3>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetPaymentsPaymentsGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
